export default "__VITE_ASSET__BXx5EBFJ__"